<script setup>
import { useBooking } from '@/composables/useBooking';
import { PACKAGES } from '@/data/packages';
import { u } from '@/data/images';
import StarRating from '@/components/ui/StarRating.vue';
import vReveal from '@/directives/reveal';

const { openBooking } = useBooking();
</script>

<template>
  <section class="packages" id="tour-packages">
    <div class="wrap">
      <div class="pkg-head" v-reveal>
        <div class="section-head" style="max-width: 620px;">
          <span class="eyebrow">Curated Tour Packages</span>
          <h2>Journeys worth crossing the world for</h2>
        </div>
        <a class="gm-btn gm-btn--ghost" href="#">View all packages</a>
      </div>
      <div class="pkg-grid">
        <article v-for="p in PACKAGES" :key="p.title" class="gm-pkg" v-reveal>
          <div class="gm-pkg__media">
            <img class="gm-pkg__img" :src="u(p.img, 700)" :alt="p.title" loading="lazy" />
            <div v-if="p.badge" class="gm-pkg__tags"><span class="gm-badge gm-badge--solid">{{ p.badge }}</span></div>
            <div class="gm-pkg__dur"><span class="gm-badge gm-badge--glass">{{ p.duration }}</span></div>
          </div>
          <div class="gm-pkg__body">
            <h3 class="gm-pkg__title">{{ p.title }}</h3>
            <StarRating :value="p.rating" :count="p.reviews" />
            <p class="gm-pkg__desc">{{ p.desc }}</p>
            <div class="gm-pkg__foot">
              <div class="gm-pkg__price"><b>{{ p.price }}</b><small>per person</small></div>
              <button class="gm-btn gm-btn--primary gm-btn--sm" @click="openBooking(p)">Book Now</button>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>
